module.exports = __webpack_public_path__ + "images/collectiveIntelligencePoster.8f441937f0bc84928a17c536b6a9498b.png";